module.exports = __webpack_public_path__ + "collect-28379dea9b0aa5e4b42d74ad92ff7f35.webp";